import { accordionClasses } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useLayersToolbarStyles = makeStyles(({ palette, spacing }) =>
  createStyles({
    toolbarWrapper: {
      zIndex: 500,
      width: '100%',
      position: 'relative',
      border: 'none',
      top: 0,
      margin: 0,
      pointerEvents: 'none',
    },
    toolbar: {
      backgroundColor: palette.background.paper,
      minHeight: 'unset',
      borderBottom: `1px solid ${palette.grey[600]}`,
      zIndex: 500,
      pointerEvents: 'auto',
    },
    button: {
      borderRadius: 0,
      '&:hover': {
        backgroundColor: palette.primary.light,
      },
    },
    buttonActive: {
      backgroundColor: palette.primary.light,
    },
    drawerPaper: {
      pointerEvents: 'auto',
      height: 'calc(100% - 40px)',
      minWidth: 250,
      top: 40,
      position: 'absolute',
      bottom: 0,
      overflow: 'auto',
      borderTop: `1px solid ${palette.grey[600]}`,
      boxShadow: '2px 8px 5px 0px rgb(0 0 0 / 40%)',
    },
    accordion: {
      margin: 0,
      boxShadow: 'none',
      padding: 0,
      alignItems: 'center',
      marginTop: `0 !important`,

      [`& ${accordionClasses.expanded}`]: {
        alignItems: 'center',
        minHeight: 38,
      },
    },
    accordionTitleContent: {
      margin: `0 !important`,
      alignItems: 'center',
    },
    accordionTitleRoot: {
      minHeight: 38,
    },
    arrow: {
      transitionProperty: 'transform',
      transform: 'rotate(0deg)',
    },
    autoLeftMargin: {
      marginLeft: 'auto',
    },
    arrowExpanded: {
      transform: 'rotate(180deg)',
    },
    radio: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      height: 25,
    },
    radioLabel: {
      cursor: 'pointer',
      display: 'flex',
      paddingBottom: spacing(),
    },
    entityDrawer: {
      pointerEvents: 'auto',
      width: 730,
      maxWidth: '100%',
      height: 'calc(100% - 40px)',
      top: 40,
      position: 'absolute',
      bottom: 0,
      borderTop: `1px solid ${palette.grey[600]}`,
      overflow: 'visible !important',
      boxShadow: '-2px 8px 5px 0px rgb(0 0 0 / 40%)',
    },
    lassoIcon: {
      filter: palette.mode === 'dark' ? 'brightness(0) invert(1)' : undefined,
    },
    titleAddonsWrapper: {
      marginLeft: 'auto',
    },
  })
);

export default useLayersToolbarStyles;
